import styled from 'styled-components';
import { Grid } from '@mui/material';

export const FullHeight = styled(Grid)`
    height: 100vh;
    max-height: -webkit-fill-available;
`;
